/**
 * DOCS SELECTION
 * 
 * module de gestion des selection 
 * de documents (ajout/remove)
 * depuis des pages du sites
 *  - pages produits
 *  - page resultats de recherche
 *  - pages listes de documents
 */
import $ from "jquery";
import { dialog } from "../../../../components/dialog.js";
const utils = require('../utils.js').default;

const DOCSSelection = (() => {
    const DOM_WISHLIST_DOCS_ADDTO = '.js-documents-add-to';
    const DOM_PAGE_PRODUCT_TITLE = '.js-page-title';
    const DOM_PAGE_PRODUCT_REF = '.js-product-ref';
    const POPIN_DOCUMENTS_ADD = 'popin-add-doc';
    const DOM_DOCS_ADD_POPIN_SHOW = `[data-js-dialog-open="${POPIN_DOCUMENTS_ADD}"]`;
    const DOM_DOCS_ADD_POPIN = `[data-js-dialog-id="${POPIN_DOCUMENTS_ADD}"]`;

    const GROUP_NAME_SUFFIX = 'Documentation rattachée au produit';

    let groupInfo = {};

    /**
     * DOCS ADD DOCUMENT (func)
     * 
     * ajout d'un document
     * @param {string} groupId 
     * @param {string} id 
     * @param {string} name 
     * @param {string} url 
     * @param {string} imageSrc 
     * @param {string} docs 
     */
    const docsAddDocument = (groupId, id, name, url, imageSrc, type, typeId, docs) => {
        window.DOCS.docsAddDocument(groupId, id, name, url, imageSrc, type, typeId).then((success) => {
            groupInfoRefresh();
            docs.attr('data-docs-state', 'selected');
            updateTemplate(name);
            utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {type:'success', content: `<strong>${name}</strong> - ${success.msg}`});
            utils.dispatchCustomEvent('DOCUMENTS_HAS_CHANGED', {event: 'Ajout d\'un document'});   
            utils.dispatchCustomEvent('TRACKERS_DOCUMENTS_ADD', {name, type: typeId});  
            utils.debug('DOCS ADD DOCUMENT', {groupId, id, name, url, imageSrc, type});                
        }).catch((error) => {
            utils.debug('DOCS ADD DOCUMENT', 'erreur pendant l\'ajout d\'un document'); 
            utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
        });
    };
    /**
     * DOCS REMOVE DOCUMENT (func)
     * 
     * suppression d'un document
     * @param {string} groupId 
     * @param {string} id 
     * @param {string} name 
     * @param {string} docs 
     */
    const docsRemoveDocument = (groupId, id, name, type, typeId, docs) => {
        window.DOCS.docsDelete(groupId, id).then((success) => {
            docs.attr('data-docs-state', 'not-selected');
            utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {type:'success', content: `<strong>${name}</strong> - ${success.msg}`});
            utils.dispatchCustomEvent('DOCUMENTS_HAS_CHANGED', {event: 'Suppression d\'un document'});   
            utils.dispatchCustomEvent('TRACKERS_DOCUMENTS_DELETE', {name, type: typeId});   
            utils.debug('DOCS REMOVE DOCUMENT', {groupId, id});               
        }).catch((error) => {
            utils.debug('DOCS REMOVE DOCUMENT', `erreur pendant la suppression d\'un document - ${error}`); 
            utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
        });
    };
    /**
     * DOCS SELECTION (func)
     * 
     * gestion d'ajout/suppression si 
     * l'utilisateur est PRO et connecté
     * sinon affichage d'une info bulle
     * @param {*} event 
     * @returns 
     */
    const docsSelection = (event) => {
        event.preventDefault();
        let docs = $(event.currentTarget);
        if (docs.attr('data-docs-state') === 'disable') {
            // utilisateur non connecté
            return false;
        } else if (docs.attr('data-docs-state') === 'selected') {
            // suppression du doc
            let groupId = groupInfo.id;
            let id = docs.data('docs-id');
            let name = docs.data('docs-name');
            let type = docs.data('docs-type');
            let typeId = docs.data('docs-type-id');
            docsRemoveDocument(groupId, id, name, type, typeId, docs)
        } else {
            // ajout du doc
            let groupId = getDocsGroupId();
            let id = docs.data('docs-id');
            let name = docs.data('docs-name');
            let url = docs.data('docs-url');
            let imageSrc = docs.data('docs-imagesrc');
            let type = docs.data('docs-type');
            let typeId = docs.data('docs-type-id');
            if (!window.DOCS.docsGroupExist(groupId)) {
                window.DOCS.docsAddGroup(groupId, getDocsGroupName(), getDocsGroupProductPageUrl()).then(() => {
                    docsAddDocument(groupId, id, name, url, imageSrc, type, typeId, docs);
                });
            } else {
                docsAddDocument(groupId, id, name, url, imageSrc, type, typeId, docs);
            }
        }
    };
    /**
     * GROUP INFO REFRESH
     * 
     * refresh des info du group info
     */
    const groupInfoRefresh = () => {
        groupInfo = window.DOCS.getDocsGroup(getDocsGroupId());
    }
    /**
     * SELECT DOCS IN DOM (func)
     * 
     * parsing du DOM pour selectionné les
     * documents présent dans la liste des documents
     */
    const selectDocsInDom = () => {
        $(DOM_WISHLIST_DOCS_ADDTO).each(function() {
            let docsId = $(this).data('docs-id');
            if (groupInfo.list.filter((docs) => docsId === docs.id).length) {
                $(this).attr('data-docs-state', 'selected');
            }
        });
    };
    const enableDocsSelection = () => {
        if (utils.userLogged()) {
            $(DOM_WISHLIST_DOCS_ADDTO).each(function() {
                $(this).removeAttr('disabled');
                $(this).attr('data-docs-state', 'not-selected');
                $(this).next('.c-tooltip__content').text('Ajouter à ma sélection de documents');
            });
        }
    }
    // GETTER
    /**
     * GET DOCS GROUP ID (func)
     * 
     * @returns {string}
     */
    const getDocsGroupId = () => {
        return utils.slug(getDocsGroupName());
    };
    /**
     * GET DOCS GROUP NAME (func)
     * 
     * retourne le nom du groupe de documents
     * si page produit, le nom est construit 
     * avec le nom du produit et la ref
     * @returns {string}
     */
    const getDocsGroupName = () => {
        if ($(DOM_PAGE_PRODUCT_TITLE).length && $(DOM_PAGE_PRODUCT_REF).length) {
            let name = `${GROUP_NAME_SUFFIX} - ${$(DOM_PAGE_PRODUCT_REF).text().replace('Ref.', '').replace(/\s+/g, '')}`;
            return name.replace(/\s\s+/g, ' ');
        } else {
            return 'Documentation';
        }
    };
    /**
     * GET DOCS GROUP PRODUCT PAGE URL (func)
     *
     * retourne l'url de la page produit auquel
     * le document est rattaché.
     * @returns {string}
     */
    const getDocsGroupProductPageUrl = () => {
        if ($(DOM_PAGE_PRODUCT_TITLE).length && $(DOM_PAGE_PRODUCT_REF).length) {
            return window.location.href;
        } else {
            return null;
        }
    };
    /**
     * UPDATE TEMPLATE
     * 
     * Affichage de la popin de confirmation
     * @param {string} document name 
     */
    const updateTemplate = (name) => {
        let data = {
            name
        };
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: POPIN_DOCUMENTS_ADD, data});
        // $(DOM_DOCS_ADD_POPIN).addClass('active');
        dialog.open(POPIN_DOCUMENTS_ADD);
    }
    /**
     * INIT (func)
     */
    const init = () => {
        if (utils.userLogged())  {
            enableDocsSelection();
            if (window.DOCS.docsGroupExist(getDocsGroupId())) {
                utils.debug('DOCS SELECTION', 'initialisation');  
                groupInfoRefresh();
                selectDocsInDom();
            }
        }
        $(DOM_WISHLIST_DOCS_ADDTO).off().on('click', docsSelection)
    };
    return {init}
})();
export default DOCSSelection;